import React, {useEffect, useState} from "react";
import {withAuth} from "../../../hoc/Auth";
import Api from "../../../Api";

import Loader from "../../Utils/Loader"
import Chart from "react-google-charts";
import EmptyChart from "../EmptyChart";
import useIsMobile from "../../../hooks/useIsMobile";

export default withAuth(({token}) => {

    const [chartData, setChartData] = useState(null);
    const isMobile = useIsMobile();

    useEffect(() => {
        new Api({token}).getTopErrorsDiffChart().then(
            function (response) {
                if (Boolean(response.new.length) && Boolean(response.old.length))
                    setChartData(response);
                else
                    setChartData(false);
            }
        )
    }, [])

    return (
        chartData ? (
            <Chart
                width={'100%'}
                height={isMobile ? '340px' : '300px'}
                chartType="PieChart"
                loader={<Loader/>}
                diffdata={chartData}
                options={{
                    pieSliceText: 'none',
                    legend: isMobile
                        ? {position: 'bottom', textStyle: {fontSize: 12}, maxLines: 4}
                        : {position: 'right', textStyle: {fontSize: 15}},
                    chartArea: isMobile ? {width: '94%', height: '62%', top: 16} : {width: '90%', height: '80%'},
                    diff: {innerCircle: {borderFactor: 0.08}}
                }}
                rootProps={{'data-testid': '2'}}
            />
        ) : (
            <EmptyChart/>
        )
    )
});



// WEBPACK FOOTER //
// ./src/Components/Charts/TopErrorsDiffChart/index.js